import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-explain-box',
  standalone: false,
  templateUrl: './liberro-explain-box.component.html',
  styleUrl: './liberro-explain-box.component.less',
})
export class LiberroExplainBoxComponent {
  @Input() public icon: string | null = null;
  @Input() public title = '';
  @Input() public variant: 'warning' | null = null;
}

